var map = {
	"./CA/seal.png": 1655,
	"./CA/seal.svg": 1080,
	"./CA/seal_color.png": 1656,
	"./CA/seal_reversed.svg": 1081,
	"./CA/sos-logo.png": 1657,
	"./ID/seal.png": 1658,
	"./ID/seal.svg": 1082,
	"./ID/seal_color.png": 1659,
	"./ID/seal_reversed.svg": 1083,
	"./ID/sos-logo.png": 1660,
	"./MT/mt-sos-logo.png": 1661,
	"./MT/seal.png": 1662,
	"./MT/seal.svg": 1084,
	"./MT/seal_color.png": 1663,
	"./MT/seal_white.png": 1664,
	"./ND/seal.svg": 1085,
	"./SOS/seal.svg": 1086
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;



//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals ^\.\/.*$
// module id = 221
// module chunks = 0